import {
  Autocomplete,
  AutocompleteRenderOptionState,
  CircularProgress,
  TextField,
  AutocompleteInputChangeReason,
  Box,
  AutocompleteChangeReason,
  AutocompleteChangeDetails
} from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { FieldWrapper } from './FieldWrapper'
import { get as _get } from 'lodash'
import { HTMLAttributes, ReactNode } from 'react'
import { createFilterOptions } from '@mui/material/Autocomplete'

interface TextFieldProps {
  label?: string
  options: unknown[] | undefined
  name: string
  loading?: boolean
  placeholder?: string
  getOptionLabel?: (option: any) => string
  sx?: any
  disabled?: boolean
  defaultValue?: any
  isMultiple?: boolean
  disableCloseOnSelect?: any
  inputValue?: any
  renderOption?: (
    props: HTMLAttributes<HTMLLIElement>,
    option: any,
    state: AutocompleteRenderOptionState
  ) => ReactNode
  onInputChange?: (
    event: React.SyntheticEvent<Element, Event>,
    value: string,
    reason: AutocompleteInputChangeReason
  ) => void
  onChange?: (
    event: React.SyntheticEvent<Element, Event>,
    value: any,
    reason: AutocompleteChangeReason,
    details?: AutocompleteChangeDetails<any>
  ) => void
  getOptionDisabled?: (option: unknown) => boolean
}

const filterOptions = createFilterOptions({
  stringify: (option: any) =>
    Object.keys(option)
      .map((key) => option[key])
      .join(' ')
})

export const SelectC = (props: TextFieldProps) => {
  const {
    label,
    options = [],
    isMultiple,
    disableCloseOnSelect,
    inputValue,
    name,
    loading,
    placeholder,
    getOptionLabel,
    sx,
    onInputChange,
    renderOption,
    disabled,
    defaultValue,
    onChange,
    getOptionDisabled
  } = props

  const { formState } = useFormContext()
  return (
    <Controller
      name={name}
      render={({ field }) => (
        <FieldWrapper error={_get(formState.errors, name)}>
          <Autocomplete
            id={`id-${name}`}
            size="small"
            onChange={(event, item, reason, details) => {
              field.onChange(item)
              onChange?.(event, item, reason, details)
            }}
            value={field.value}
            options={options}
            multiple={isMultiple}
            disableCloseOnSelect={disableCloseOnSelect}
            inputValue={inputValue}
            filterOptions={filterOptions}
            autoHighlight
            getOptionDisabled={getOptionDisabled}
            noOptionsText="Nenhum resultado encontrado..."
            loadingText="Carregando..."
            onInputChange={onInputChange}
            loading={loading}
            getOptionLabel={getOptionLabel}
            sx={sx}
            disabled={!!disabled}
            defaultValue={defaultValue}
            isOptionEqualToValue={(opt, value) => {
              return JSON.stringify(opt) === JSON.stringify(value)
            }}
            renderOption={renderOption}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                placeholder={placeholder}
                error={!!_get(formState.errors, name)}
                InputProps={{
                  ...params.InputProps,
                  autoComplete: 'off',
                  endAdornment: (
                    <Box
                      sx={{
                        paddingRight: 3.5,
                        display: 'flex',
                        alignSelf: 'center'
                      }}
                    >
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}

                      {params.InputProps.endAdornment}
                    </Box>
                  )
                }}
              />
            )}
          />
        </FieldWrapper>
      )}
    />
  )
}

SelectC.defaultProps = {
  loading: false
}
